const ITEMS = ["Dal 2024", "Dai Giovani per i Giovani", "Artemide FC"];

export default function Marquee() {
  const row = ITEMS.map((i) => `${i}  /  `).join("");
  return (
    <div className="overflow-hidden border-y-2 border-line bg-night py-5 select-none" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((i) => (
          <span key={i} className="font-display font-black uppercase text-4xl sm:text-6xl text-stroke-gold pr-4">
            {row.repeat(3)}
          </span>
        ))}
      </div>
    </div>
  );
}
